import { Controller } from "@hotwired/stimulus"

// Remittances to third parties and social declarations (GO4SXPENSE): what
// may be handed over or declared depends on the day chosen. When the date
// changes, the amount proposed, and its ceiling, become what was due on
// that day, and the line under the form says so (finance test run). The
// server keeps the rule and refuses above it, saying the amount.
export default class extends Controller {
  static targets = ["amount", "date", "hint"]
  static values = { url: String }

  disconnect() {
    this.request?.abort()
  }

  async refresh() {
    const date = this.dateTarget.value
    if (!date) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("date", date)
    this.request?.abort()
    this.request = new AbortController()

    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        signal: this.request.signal,
      })
      if (!response.ok) return

      const { amount, message } = await response.json()
      if (Number.isInteger(amount)) {
        this.amountTarget.value = amount
        this.amountTarget.max = amount
      }
      if (this.hasHintTarget && message) this.hintTarget.textContent = message
    } catch (error) {
      if (error.name !== "AbortError") console.error(error)
    }
  }
}
